import { useEffect, useState } from "react";
import { connect } from "react-redux";

import CustomModal from "../../../common/CustomModal";
import CustomButton from "../../../common/CustomButton";
import { BsThreeDots } from "react-icons/bs";

import { AcceptChallenge, LeaveChallenge, } from "../../../redux/v2/challenge/actions";
import { delay } from "../../../utils";
import useMilestones from "../../../hooks/useMilestones";
import useSVG from "../../../hooks/useSVG";
import useCountDown from "../../../hooks/useCountDown";
import useAccomplishments from "../../../hooks/useAccomplishments";

import Milestone from "./Milestone";
import toast from "react-hot-toast";
import PaddedContentArea from "../../../common/PaddedContentArea";

import MediaDetailsContainer from "../../../common/MediaDetailsContainer";
import WelcomeMessage from "./WelcomeMessage";

function ChallengeDetails(props) {
    const { challenge, status, screenSize, showWelcomeMsg, fireConfetti } = props;
    const { myChallenges, histories } = props.Challenge;
    const { user } = props.User;

    const [accepted, setAccepted] = useState(false);
    const [clicked, setClicked] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [accompDelay, setAccompDelay] = useState(0);
    const { accomplishment } = useAccomplishments({ challenge, histories });
    const { UseChalengesSVG } = useSVG();
    const { milestones, current } = useMilestones({ challenge: challenge, accomplishment: accompDelay });
    const { days } = useCountDown({ challenge: challenge });

    let isDone = current?.index == milestones?.length - 1 && current?.isComplete;
    let url = process.env.REACT_APP_ENVIRONMENT == "PROD" ? process.env.REACT_APP_BASE_API_URL : process.env.REACT_APP_BASE_API_URL_DEV;

    useEffect(() => {

        let isAccepted = false;

        myChallenges.map((mc) => {
            if (mc.challengeID == challenge?.id) {
                isAccepted = true;
            }
        })

        setAccepted(isAccepted);
    }, [myChallenges, challenge])

    useEffect(() => {
        if (accepted || accomplishment) {
            setAccompDelay(accomplishment);
        } else {
            setAccompDelay(0)
        }
    }, [accepted, accomplishment])

    const gradient = challenge?.gradient?.split("-");

    const JoinChallenge = async () => {
        if (!clicked) {
            setClicked(true);

            const toastId = toast.loading("Accepting challenge...");

            const res = await props.AcceptChallenge(challenge.id);
            setClicked(false);
            // setAccepted(res.success);
            if (res.success) {
                toast.success('Challenge accepted.', {
                    id: toastId,
                });
                showWelcomeMsg(true);
                delay(() => {
                    fireConfetti();
                }, 300)
            } else {
                toast.success('Failed to accept.', {
                    id: toastId,
                });
            }
        }
    }

    return (
        <div id="challenge-details" className={challenge?.company ? "cd-company" : ""}>
            <CustomModal
                id="delete-ad"
                show={showModal}
                toggle={() => setShowModal(!setShowModal)}
                title="Leave Challenge"
                body={
                    <>
                        Are you sure you want to leave {challenge?.title}?
                    </>
                }
                footerButtons={
                    [
                        {
                            label: "YES",
                            action: async () => {
                                if (!clicked) {
                                    setClicked(true);

                                    const toastId = toast.loading("Leaving challenge...");
                                    const res = await props.LeaveChallenge(challenge.id);
                                    setClicked(false);

                                    if (res.success) {
                                        setAccepted(false);
                                        toast.success('Successful.', {
                                            id: toastId,
                                        });
                                        setShowModal(false);
                                    } else {
                                        toast.error('Failed to leave.', {
                                            id: toastId,
                                        });
                                    }
                                }
                            },
                        }
                    ]
                }
            />

            <PaddedContentArea>
                <MediaDetailsContainer
                    className="challenge-card"
                    media={(
                        <>
                            <div id="cc-challenge-icon-wrapper" style={challenge?.gradient ? { backgroundImage: `linear-gradient(to right, ${gradient?.[0]}, ${gradient?.[1]})` } : null}>
                                {
                                    challenge?.company
                                        ? <img src={(challenge?.secondary_image || challenge?.image) ? (url + "images/challenges/" + (challenge?.secondary_image || challenge?.image)) : (url + challenge?.badge)} />
                                        : (challenge?.svg ? UseChalengesSVG(challenge?.svg) : "")
                                }
                            </div>
                            <div id="cc-title-area-anch" className="cc-title-area">
                                <h4>{challenge?.title}</h4>
                                <p>{days}</p>
                                {
                                    screenSize == "xl" &&
                                    <p>
                                        {
                                            challenge?.company
                                                ? `Join ${user?.name} in crushing your company challenge milestones! Complete your workouts to reach your goals.`
                                                : challenge?.description
                                        }
                                    </p>
                                }

                                {
                                    screenSize != "xl" &&
                                    <div className="cc-div-links">
                                        <a href="#cc-title-area-anch">About</a>
                                        <a href="#challenge-welcome-message">Eligible Programs</a>
                                    </div>
                                }

                            </div>
                        </>
                    )}

                    details={(
                        <div>
                            {
                                screenSize != "xl" &&
                                <>
                                    {/* <div>
                                        <h4>{challenge?.title}</h4>
                                        <p>{days}</p>
                                    </div> */}
                                    <p>
                                        {
                                            challenge?.company
                                                ? `Join ${user?.name} in crushing your company challenge milestones! Complete your workouts to reach your goals.`
                                                : challenge?.description
                                        }
                                    </p>
                                </>
                            }

                            <div id="cc-milestones">

                                {
                                    milestones?.map((milestone, i) => {
                                        return (
                                            <Milestone
                                                type={milestone?.type}
                                                value={challenge?.status != 0 ? milestone?.value : 0}
                                                max={milestone?.max}
                                                min={milestone?.min}
                                                stage={milestone?.stage}
                                                challenge={challenge}
                                            />
                                        )

                                    })
                                }

                            </div>
                            {
                                <div>
                                    <WelcomeMessage challenge={challenge} minimal={true} />
                                </div>
                            }

                            {
                                !challenge?.company && <>
                                    {
                                        (accepted && (status != "completed" && !challenge?.statusType2)) &&
                                        <div id="cc-leave-button">
                                            <h6 onClick={() => {
                                                setShowModal(true);
                                            }}>LEAVE CHALLENGE</h6>
                                        </div>
                                    }

                                    {
                                        (status == "completed" && !isDone) &&
                                        <div id="cc-leave-button">
                                            <h6 onClick={() => {
                                                // setShowModal(true);
                                            }}>REMOVE CHALLENGE</h6>
                                        </div>
                                    }

                                    {
                                        (!accepted && (challenge?.statusType == "active" || challenge?.statusType == "upcoming") && screenSize == "xl") &&
                                        <div id="cc-accept-button-wide-screen">
                                            <CustomButton className="active" onClick={JoinChallenge}>JOIN CHALLENGE</CustomButton>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    )}
                />

                {
                    !challenge?.company && <>
                        {
                            (!accepted && (challenge?.statusType == "active" || challenge?.statusType == "upcoming") && screenSize != "xl") &&
                            <div id="cc-accept-button">
                                <CustomButton className="active" onClick={JoinChallenge}>JOIN CHALLENGE</CustomButton>
                            </div>
                        }
                    </>
                }
            </PaddedContentArea>
        </div>
    );
}

const mapStateToProps = (state) => ({
    Challenge: state.Challenge,
    User: state.User,
});

export default connect(mapStateToProps, {
    AcceptChallenge,
    LeaveChallenge,
})(ChallengeDetails);